<template>
  <div class="mt-60">
    <div class="boires-page-loader-div" v-if="isLoading">
      <div class="boires-page-loader"></div>
    </div>
    <MainLayout>
      <div class="container text-left">
        <h2 class="title text-uppercase text-left mb-10">
          {{ title }}
        </h2>
        <mq-layout :mq="['xs', 'sm', 'md']" class="mb-20">
          <p
            class="paragraph2 text-left products-subtitle products-subtitle__mobile"
          >
            <span>{{ subtitle1 }}</span>
            <br />
            <span>{{ subtitle2 }}</span>
            <span
              v-if="
                productType == 'STORE_MTL' ||
                productType == 'STORE_QC' ||
                productType == 'STORE_TORONTO'
              "
            >
              <el-popover
                placement="top-start"
                title=""
                width="290"
                trigger="click"
                :hide="hideShowpopup(botiqueDescription)"
                :popperClass="hideShowPopupModel"
              >
                <div v-html="botiqueDescription"></div>
                <i
                  style="font-size: 16px"
                  slot="reference"
                  class="el-icon-question ml-5"
                ></i>
              </el-popover>
            </span>
            <span v-else>
              <el-popover
                placement="top-start"
                title=""
                width="300"
                trigger="click"
                :hide="hideShowpopup(agencyDescription)"
                :popperClass="hideShowPopupModel"
              >
                <div v-html="agencyDescription"></div>
                <i
                  style="font-size: 16px"
                  slot="reference"
                  class="el-icon-question ml-5"
                ></i>
              </el-popover>
            </span>
            <!-- <i class="el-icon-question ml-5" /> -->
          </p>
        </mq-layout>

        <mq-layout v-if="isMounted" mq="lg+" class="mb-20">
          <p
            class="paragraph2 text-left products-subtitle"
            v-if="!isMobileLayout"
          >
            <span>{{ subtitle }}</span>
            <!-- <span
              v-if="
                productType == 'STORE_MTL' ||
                productType == 'STORE_QC' ||
                productType == 'STORE_TORONTO'
              "
            >
              <el-popover
                placement="top-start"
                title=""
                width="290"
                trigger="hover"
                :hide="hideShowpopup(botiqueDescription)"
                :popperClass="hideShowPopupModel"
              >
                <div v-html="botiqueDescription"></div>
                <i
                  style="font-size: 16px"
                  slot="reference"
                  class="el-icon-question ml-5"
                ></i>
              </el-popover>
            </span>
            <span v-else>
              <el-popover
                placement="top-start"
                title=""
                width="700"
                trigger="hover"
                :hide="hideShowpopup(agencyDescription)"
                :popperClass="hideShowPopupModel"
              >
                <div v-html="agencyDescription"></div>
                <i
                  style="font-size: 16px"
                  slot="reference"
                  class="el-icon-question ml-5"
                ></i>
              </el-popover>
            </span> -->
          </p>
        </mq-layout>
      </div>

      <FilterBar
        id="filter-bar"
        :filter-count="filterCount"
        @emit-filter-reset="emitResetFilters();resetSelectedFilter();"
        @emit-filter-click="emitToggleFilter"
        @emit-pdf-download="getPDF"
        @emit-shorting-change="shortedBy"
      />
      <div id="products" class="mt-16">
        <el-row>
          <mq-layout :mq="['xs', 'sm', 'md']" class="container">
            <el-col :span="24">
              <div
                v-if="
                  changeProductView &&
                  products &&
                  displayedProducts &&
                  displayedProducts.length > 0
                "
              >
                <ProductCardsList
                  id="product-cards-list-md"
                  :products="displayedProducts"
                  :tax-code="actionBar && actionBar.tax"
                  :list-type="viewType"
                  :filters="filters"
                  :span="12"
                  :product-type="productType"
                  @emit-stop-loading="stopLoading()"
                  @emit-start-loading="startLoading()"
                />
                <vue-html2pdf
                  :show-layout="false"
                  :float-layout="true"
                  :enable-download="true"
                  :preview-modal="true"
                  :paginate-elements-by-height="1400"
                  :pdf-quality="2"
                  :manual-pagination="true"
                  pdf-format="a4"
                  pdf-orientation="landscape"
                  pdf-content-width="100%"
                  :html-to-pdf-options="htmlToPdfOptions"
                  ref="html2Pdf"
                >
                  <section slot="pdf-content">
                    <div class="pdf-logo mb-20 pt-10">
                      <img :src="image.logo" alt="" class="pdf-logo-img" />
                    </div>
                    <ProductCardsList
                      id="product-cards-list-lg product-cards-pdf"
                      :products="displayedProducts"
                      :tax-code="actionBar && actionBar.tax"
                      :span="$mq === 'lg' ? 8 : 6"
                      :is-filter-visible="isFilterVisible"
                      :list-type="viewType"
                      :product-type="productType"
                      :filters="filters"
                      :isPdf="true"
                      :circleXs="1"
                      :typeNameXs="3"
                      :inventoryXs="1"
                      :titleXs="10"
                      :yearXs="2"
                      :volumeXs="2"
                      :caisseXs="1"
                      :priceXs="2"
                      :disponibiliteXs="2"
                    />
                  </section>
                </vue-html2pdf>
              </div>
              <div v-else class="text-center mt-100 no-records-found">
                <h4>
                  {{ noRecordsFound }}
                </h4>
              </div>
            </el-col>
          </mq-layout>
          <mq-layout
            v-if="isMounted && !isMobileView"
            mq="lg+"
            class="container"
          >
            <el-col :span="isFilterVisible ? 4 : 0">
              <ProductFilters
                v-if="filterRender"
                :filters="filters"
                :attributes-model="selectedFilters.attributes"
                :availability-model="selectedFilters.availability"
                :product-types-model="selectedFilters.productTypes"
                :countries-model="selectedFilters.countries"
                :regions-model="selectedFilters.regions"
                :min-price-model="selectedFilters.minPrice"
                :max-price-model="selectedFilters.maxPrice"
                :availabilityStatusModel="selectedFilters.availabilityStatus"
                :filter-reset="filterReset"
                :product-inventory="productInventory"
                @filter-change="updateSelectedFilters($event)"
                @filter-reset="initFilterReset"
              />
            </el-col>
            <el-col :span="isFilterVisible ? 20 : 24">
              <div
                v-if="
                  changeProductView &&
                  products &&
                  displayedProducts &&
                  displayedProducts.length > 0
                "
                ref="createPdf"
                id="print"
              >
                <div>
                  <ProductCardsList
                    id="product-cards-list-lg"
                    :products="displayedProducts"
                    :tax-code="actionBar && actionBar.tax"
                    :span="$mq === 'lg' ? 8 : 6"
                    :is-filter-visible="isFilterVisible"
                    :list-type="viewType"
                    :product-type="productType"
                    :filters="filters"
                    :minPriceModel="minPriceModel"
                    :maxPriceModel="maxPriceModel"
                    @emit-stop-loading="isLoading = false"
                  />
                  <vue-html2pdf
                    :show-layout="false"
                    :float-layout="true"
                    :enable-download="true"
                    :preview-modal="true"
                    :paginate-elements-by-height="1400"
                    :pdf-quality="2"
                    :manual-pagination="true"
                    pdf-format="a4"
                    pdf-orientation="landscape"
                    pdf-content-width="100%"
                    :html-to-pdf-options="htmlToPdfOptions"
                    ref="html2Pdf"
                  >
                    <section slot="pdf-content">
                      <div class="pdf-logo mb-20 pt-10">
                        <img :src="image.logo" alt="" class="pdf-logo-img" />
                      </div>
                      <ProductCardsList
                        id="product-cards-list-lg product-cards-pdf"
                        :products="displayedProducts"
                        :tax-code="actionBar && actionBar.tax"
                        :span="$mq === 'lg' ? 8 : 6"
                        :is-filter-visible="isFilterVisible"
                        :list-type="viewType"
                        :product-type="productType"
                        :filters="filters"
                        :isPdf="true"
                      />
                    </section>
                  </vue-html2pdf>
                </div>
              </div>
              <div v-else class="text-center mt-100 no-records-found">
                <h4>
                  {{ noRecordsFound }}
                </h4>
              </div>
            </el-col>
          </mq-layout>
        </el-row>
      </div>
      <div class="mb-60">
        <el-row>
          <div class="container">
            <el-divider class="mt-4 mb-4" />
            <el-col :span="24">
              <div :class="isMobileLayout ? 'text-center' : 'text-right'">
                <Pagination
                  :current-page="currentPage"
                  :total-number-of-page="totalNumberOfPage"
                  @click-previous="clickPrevious"
                  @click-next="clickNext"
                />
              </div>
            </el-col>
          </div>
        </el-row>
      </div>
      <el-drawer
        v-if="isMobileView"
        id="drawer"
        ref="drawer"
        title="Filtrer"
        :visible.sync="isMobileFilterVisible"
        :direction="direction"
        :before-close="handleClose"
        :size="drawerSize"
        :class="isMobileFilterVisible && $mq == 'sm' && 'filter-full'"
      >
        <div class="filter--mobile">
          <ProductFilters
            v-if="filterRender"
            :filters="filters"
            :attributes-model="selectedFilters.attributes"
            :availability-model="selectedFilters.availability"
            :product-types-model="selectedFilters.productTypes"
            :availabilityStatusModel="selectedFilters.availabilityStatus"
            :countries-model="selectedFilters.countries"
            :regions-model="selectedFilters.regions"
            :min-price-model="selectedFilters.minPrice"
            :max-price-model="selectedFilters.maxPrice"
            :filter-reset="filterReset"
            @filter-change="updateSelectedFilters($event)"
            @filter-reset="initFilterReset"
          />
          <div v-if="isMobileLayout" class="mt-16 mr-16 text-right">
            <el-button @click="handleClose()">
              {{ cancelButton }}
            </el-button>
            <el-button type="primary">
              {{ filterButton }}
            </el-button>
          </div>
        </div>
      </el-drawer>
    </MainLayout>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";

import { ceil, forEach, isEmpty, get } from "@/utils/lodash";
import { debounce } from "lodash";
import layoutUtils from "@/utils/layout-utils";
import { availabilityStatusToQuery, getConsignmentInventory, getBoardInventory, getDefaultAvailability, isBoutiqueInventory, parseAvailabilityStatusQuery } from "@/utils/market-utils";

import FilterBar from "@/components/filter-bar.vue";
import MainLayout from "@/components/layout/main-layout.vue";
import Pagination from "@/components/pagination.vue";

import ProductCardsList from "./components/product-cards-list.vue";
import ProductFilters from "./components/product-filters.vue";

import VueHtml2pdf from "vue-html2pdf";
import pdfLogo from "@/assets/images/logo/logo-red.png";

import { wrapInArray } from "@/utils/common-utils";

export default {
  components: {
    MainLayout,
    FilterBar,
    Pagination,
    ProductCardsList,
    ProductFilters,
    VueHtml2pdf,
  },
  props: {
    page: {
      type: Number,
      default: 1,
    },
    productTypesModel: {
      type: Array,
      default: () => [],
    },
    availabilityModel: {
      type: Array,
      default: () => ["IP", "SAQ", "STORE_MTL"],
    },
    availabilityStatusModel: {
      type: Array,
      default: () => ["AVAILABLE", "UPCOMING"],
    },
    attributesModel: {
      type: Array,
      default: () => [],
    },
    countriesModel: {
      type: Array,
      default: () => [],
    },
    regionsModel: {
      type: Array,
      default: () => [],
    },
    textModel: {
      type: String,
      default: "",
    },
    minPriceModel: {
      type: Number,
      default: null,
    },
    maxPriceModel: {
      type: Number,
      default: null,
    },
    productInventoryModel: {
      type: Array,
      default: () => [],
    },
    setProductTypes: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      filterCount: 0,
      // How many options each flat filter section offers, reported by the
      // sidebar (see getOptionTotals there). Used to tell "every option" apart
      // from "some options" when counting active filters.
      optionTotals: {},
      selectedFilters: {
        productTypes: this.productTypesModel.slice(),
        availability:
          this.productInventoryModel && this.productInventoryModel.length > 0
            ? this.productInventoryModel.slice()
            : this.availabilityModel.slice(),
        attributes: this.attributesModel.slice(),
        countries: this.countriesModel.slice(),
        regions: this.regionsModel.slice(),
        availabilityStatus: this.availabilityStatusModel.slice(),
        text: this.textModel,
        minPrice: this.minPriceModel,
        maxPrice: this.maxPriceModel,
        sortByQty:'',
        sortByPrice:'',
        show: availabilityStatusToQuery(this.availabilityStatusModel),
      },
      isMobileFilterVisible: false,
      isFilterVisible: false,
      drawer: false,
      direction: "ltr",
      isMounted: false,
      filterReset: false,
      currentPage: this.$route.query.page ? Number(this.$route.query.page) : 1,
      viewType: "tuiles",
      changeProductView: true,
      htmlToPdfOptions: {
        margin: [0.1, 0.2, 0.3, 0],
        filename: `${Math.round(+new Date() / 1000)}.pdf`,
        image: {
          type: "jpeg",
          quality: 2,
        },
        enableLinks: false,
        html2canvas: {
          scale: 1,
          useCORS: true,
        },
        jsPDF: {
          unit: "in",
          format: "a4",
          orientation: "portrait",
        },
      },
      image: {
        logo: pdfLogo,
      },
      filterRender: true,
      // Set by updateSelectedFilters(), cleared only by getProducts(). Kept off
      // `selectedFilters` so a later call cannot cancel a queued fetch.
      pendingFetch: false,
      hideShowPopupModel: "",
      isLoading: true,
      defaultShorting: '',
      showProduct: true,
      newWindow: null,
    };
  },
  computed: {
    ...mapState("product", ["products", "filters"]),
    ...mapState("configuration", ["actionBar"]),
    isStrictUpcoming() {
      return this.$route.query.strictUpcoming === "1";
    },
    // See isBoutiqueInventory(): `inventory` in the URL means "retail store"
    // only when it holds a STORE_* code. On the agency products page the same
    // param carries the entrepôt selection, so it must not flip the page into
    // boutique mode.
    isBoutiquePage() {
      return isBoutiqueInventory(this.$route.query.inventory);
    },
    displayedProducts() {
      const results = (this.products && this.products.results) || [];
      if (!this.isStrictUpcoming) return results;
      return results.filter((p) => {
        const inStock = Number(get(p, "quantity.inStock", 0));
        const pendingQty = Number(get(p, "itemToCome.pendingQty", 0));
        return inStock === 0 && pendingQty > 0;
      });
    },
    title() {
      let productInventoryModel = this.productInventory;
      if (productInventoryModel === "STORE_MTL") {
        return this.$i18n.t("products.boutiqueProductsView.title");
      } else if (productInventoryModel === "STORE_QC") {
        return this.$i18n.t("products.boutiqueProductsQuebecView.title");
      } else if (productInventoryModel === "STORE_TORONTO") {
        return this.$i18n.t("products.boutiqueProductsTorontoView.title");
      }
      return this.$i18n.t("products.productsView.title");
    },
    subtitle() {
      let productInventoryModel = this.productInventory;
      if (productInventoryModel === "STORE_MTL") {
        return this.$i18n.t("products.boutiqueProductsView.subtitle1");
      } else if (productInventoryModel === "STORE_QC") {
        return this.$i18n.t("products.boutiqueProductsQuebecView.subtitle1");
      } else if (productInventoryModel === "STORE_TORONTO") {
        return this.$i18n.t("products.boutiqueProductsTorontoView.subtitle1");
      }
      if (!this.isBoutiquePage) {
        return `${this.$i18n.t("products.productsView.subtitle1")} ${this.$i18n.t(
          "products.productsView.subtitle2",
        )}`;
      }
      return '';
    },
    subtitle1() {
      let productInventoryModel = this.productInventory;
      if (productInventoryModel === "STORE_MTL") {
        return this.$i18n.t("products.boutiqueProductsView.subtitle1");
      } else if (productInventoryModel === "STORE_QC") {
        return this.$i18n.t("products.boutiqueProductsQuebecView.subtitle1");
      } else if (productInventoryModel === "STORE_TORONTO") {
        return this.$i18n.t("products.boutiqueProductsTorontoView.subtitle1");
      }
      return this.$i18n.t("products.productsView.subtitle1");
    },
    subtitle2() {
      let productInventoryModel = this.productInventory;
      if (productInventoryModel === "STORE_MTL") {
        return this.$i18n.t("products.boutiqueProductsView.subtitle2");
      } else if (productInventoryModel === "STORE_QC") {
        return this.$i18n.t("products.boutiqueProductsQuebecView.subtitle2");
      } else if (productInventoryModel === "STORE_TORONTO") {
        return this.$i18n.t("products.boutiqueProductsTorontoView.subtitle2");
      }
      return this.$i18n.t("products.productsView.subtitle2");
    },
    noRecordsFound() {
      return this.$i18n.t("common.noRecordsFound");
    },
    isMobileLayout() {
      return layoutUtils.isMobileLayout(this.$mq);
    },
    drawerSize() {
      return this.innerWidth <= 414 ? "100%" : "414px";
    },
    cancelButton() {
      return this.$i18n.t("products.filters.button.cancel");
    },
    filterButton() {
      return this.$i18n.t("products.filters.button.filter");
    },
    numberOfProductPerPage() {
      if (this.isStrictUpcoming) {
        // Fetch all in one page so the client-side filter
        // (inStock=0 && pendingQty>0) doesn't leave short pages.
        return 500;
      }
      let numberOfProducts = 52;
      if (this.isMounted) {
        switch (this.$mq) {
          case "xs":
          case "sm":
          case "md":
            numberOfProducts = 51;
            break;
          case "lg":
            numberOfProducts = 51;
            break;
          default:
            break;
        }
      }
      return numberOfProducts;
    },
    isMobileView() {
      let isMobileView = false;
      if (this.isMounted) {
        switch (this.$mq) {
          case "md":
            isMobileView = true;
            break;
          case "sm":
            isMobileView = true;
            break;
          default:
            break;
        }
      }
      return isMobileView;
    },
    totalNumberOfPage() {
      if (this.isStrictUpcoming) {
        return 1;
      }
      const numberOfPages =
        this.products &&
        ceil(this.products.total / this.numberOfProductPerPage);
      return numberOfPages != null && numberOfPages > 0 ? numberOfPages : 1;
    },
    productInventory() {
      return this.productInventoryModel[0];
    },
    productType() {
      if (this.productTypesModel[0] && this.productTypesModel[0] != "") {
        return this.productTypesModel[0];
      }
      return "";
    },
    botiqueDescription() {
      let productInventoryModel = this.productInventory;
      if (productInventoryModel === "STORE_MTL") {
        return this.$i18n.t("products.boutiqueProductsView.description");
      } else if (productInventoryModel === "STORE_QC") {
        return this.$i18n.t("products.boutiqueProductsQuebecView.description");
      } else if (productInventoryModel === "STORE_TORONTO") {
        return this.$i18n.t("products.boutiqueProductsTorontoView.description");
      }
      return this.$i18n.t("products.boutiqueProductsView.description");
    },
    agencyDescription() {
      return this.$i18n.t("products.productsView.description");
    },
  },
  watch: {
    numberOfProductPerPage() {
      this.redirectAfterPageChange();
    },
    setProductTypes: {
      immediate: true,
      handler(val, oldVal) {
      // `oldVal === undefined` only on the immediate run at create time, where
      // the initial fetch is driven by `!products.results` anyway. Every later
      // run means the `type` query param actually changed — either the user
      // ticked a Type checkbox or a footer/CMS link navigated in place — and
      // that must always re-query.
      //
      // This used to pass `req: false` whenever a type WAS selected. getProducts
      // is debounced and reads `selectedFilters.req` at execution time, so this
      // handler (which runs after the router.replace triggered by the filter
      // change) cleared the flag the filter change had just set, and the pending
      // fetch was skipped: ticking a Type updated the URL and the checkbox but
      // never the results, so Type could not be combined with any other filter.
      const isInitialRun = oldVal === undefined;
      this.updateSelectedFilters({
        productTypes: wrapInArray(this.setProductTypes),
        availability:
          this.productInventoryModel && this.productInventoryModel != ""
            ? this.productInventoryModel
            : this.availabilityModel,
        availabilityStatus:this.selectedFilters.availabilityStatus.length > 0 ? this.selectedFilters.availabilityStatus: this.availabilityStatusModel,
        attributes: this.attributesModel,
        countries: this.countriesModel,
        regions: this.regionsModel,
        minPrice: this.minPriceModel,
        maxPrice: this.maxPriceModel,
        req: isInitialRun ? val.length == 0 : true,
      });

      if (
        val.length == 0 ||
        (this.$route.query.req == true &&
          this.$route.query.type &&
          this.$route.query.type.length > 0)
      ) {
        this.filterRender = false;
        this.$nextTick(() => {
          this.filterRender = true;
        });
      }

      if (this.$route.query.req == true) {
        let route = { ...this.$route.query };
        delete route.req;
        // this.viewType = 'tuiles';
        // localStorage.setItem("viewType", 'tuiles');
        this.$router.replace({ name: "products", query: { ...route } });
      }
      this.reRenderProductView();
      },
    },
    title(newVal) {
      this.hideShowPopupModel = "";
      if (newVal && newVal != "") {
        let productInventoryModel = this.productInventory;
        if (
          productInventoryModel === "STORE_MTL" ||
          productInventoryModel === "STORE_QC"
        ) {
          this.$root.$emit("changeProductPage", {
            request: "fr-CA",
            code: "FR",
          });
        } else if (productInventoryModel === "STORE_TORONTO") {
          this.$root.$emit("changeProductPage", {
            request: "en-US",
            code: "EN",
          });
        }
      }
    },
    productInventoryModel() {
      this.reRenderProductView();
    },
    products(val) {
      if(val.results){
        forEach(val.results, (e) => {
          if (e.productInventories) {
            const market = localStorage.getItem("countryCode") || "QC";
            let price = e.productInventories.find((r) =>r.id == e.id &&(r.inventory.code == getConsignmentInventory(market) || r.inventory.code == getBoardInventory(market)));
            if (price) {
              e.erpProduct = price;
              e.inventory = e.erpProduct.inventory;
            }
          } else {
            e.erpProduct = e;
          }
        });
        // if(val.results && this.selectedFilters.availability && this.selectedFilters.availability.length > 0){
        //   val.results = val.results.filter((f)=> {
        //     if(this.selectedFilters.availability.indexOf(f.inventory.code) != -1){
        //       return f
        //     }
        //   })
        // }
      }
      this.reRenderProductView();
      this.totalNumberOfPage;
    },
    // 'actionBar.country'(newVal, oldVal) {
    //   if (newVal !== oldVal) {
    //     this.$router.push('/');
    //   }
    // }
  },
  created() {
    // this.emitResetFilters();
    this.fetchProductFilters({});
    let productInventoryModel = this.productInventory;
    if (
      productInventoryModel === "STORE_MTL" ||
      productInventoryModel === "STORE_QC"
    ) {
      this.$root.$emit("changeProductPage", {
        request: "fr-CA",
        code: "FR",
      });
    } else if (productInventoryModel === "STORE_TORONTO") {
      this.$root.$emit("changeProductPage", {
        request: "en-US",
        code: "EN",
      });
    }
  },
  beforeDestroy() {
    this.$root.$off("chanLang", this.$_onLang);
    this.$root.$off("chancountryCode", this.$_onCountry);
    this.$root.$off("changeTax", this.$_onTax);
  },
  mounted() {
    this.startLoading();
    if (!this.isMobileLayout) {
    // localStorage.setItem("viewType", 'tuiles');
    }
    if (this.$route.query.req) {
      let route = { ...this.$route.query };
      // delete route.req;
      this.$router.replace({ name: "products", query: { ...route } });
    }
    // Keep handler references so beforeDestroy can $off them (otherwise these
    // $root listeners leak on every visit and all fire on a region/lang switch).
    this.$_onLang = () => {
      this.redirect({
        ... this.selectedFilters,
        req : true
      });
      this.fetchProductFilters({});
    };
    this.$_onCountry = (countryCode) => {
      // The entrepôt selection is market-specific: IP/SAQ/Brouhh/MERCH_MTL/
      // BERGEVILLE mean nothing in Ontario, and LCBO/PI/MERCH_TORONTO mean
      // nothing in Quebec. Switching markets used to keep the old codes and
      // write them straight back into the URL, so the Ontario site went on
      // listing Quebec products ("il n'y a pas 5 pages de produits ontariens").
      // A reload could not fix it — the stale codes were IN the URL — which is
      // why only leaving the page and coming back worked: that re-derives the
      // selection from getDefaultAvailability() in the router props. Everything
      // filtered from that point on was filtering the wrong market's catalogue.
      //
      // The boutique is exempt: there `inventory` is the STORE_* page identity,
      // not a warehouse selection.
      if (!this.isBoutiquePage) {
        const market = countryCode || localStorage.getItem("countryCode");
        this.selectedFilters.availability = getDefaultAvailability(market);
      }

      this.redirect({
        ... this.selectedFilters,
        req : true
      });
      this.currentPage = 1;
      if(this.$route.name === 'products') {
        this.$router.replace({
              name: "products",
              query: { ...this.$route.query, page: 1 },
            })
      }
    };
    this.$_onTax = () => {
      this.redirect({
        ... this.selectedFilters,
        req : true
      });
    };
    this.$root.$on("chanLang", this.$_onLang);
    this.$root.$on("chancountryCode", this.$_onCountry);
    this.$root.$on("changeTax", this.$_onTax);
    let productInventoryModel = this.productInventory;
    if (
      (productInventoryModel === "STORE_MTL" ||
        productInventoryModel === "STORE_QC") &&
      this.$i18n.locale == "en-US"
    ) {
      // this.$root.$emit('changeProductPage', {request:'fr-CA',code:'FR'});
    } else if (
      productInventoryModel === "STORE_TORONTO" &&
      this.$i18n.locale == "fr-CA"
    ) {
      // this.$root.$emit('changeProductPage', {request:'en-US',code:'EN'});
    }
    this.updateFiltersCount();

    // to make sure parent is mounted before sending values to children props (ex: map-state-filters)
    this.isMounted = true;
    this.$root.$on("viewType", (viewType) => {
      this.viewType = viewType;
      this.reRenderProductView();
      this.startLoading();
      setTimeout(() => {
        this.stopLoading();
      }, 1000);
    });

    if (this.isMobileLayout) {
      this.updateSelectedFilters(this.selectedFilters);
    }
  },
  methods: {
    ...mapActions("product", [
      "fetchProducts",
      "fetchProductsBoutique",
      "fetchProductFilters",
      "downloadPDF",
    ]),
    ...mapMutations("filter", ["RESET_FILTERS"]),
    // eslint-disable-next-line no-undef
    getProducts: debounce(function(filters) {
      // The fetch intent must NOT live on `selectedFilters`. This function runs
      // 500ms after it is scheduled and reads the flag off that shared, mutable
      // object, while every updateSelectedFilters() call resets `req` to false
      // on entry — so any call landing inside the debounce window silently
      // cancelled the fetch that was already queued. The list then kept
      // rendering the previous query's results (a filter change appeared to do
      // nothing, and once it landed on an empty set it stayed empty) until a
      // manual reload. It is a race, which is why it reproduced only sometimes.
      //
      // `pendingFetch` is sticky: callers can only ever set it, and only the
      // fetch below clears it.
      const shouldFetch = !this.products.results || this.pendingFetch || filters.req == true;
      this.pendingFetch = false;
      if (shouldFetch) {
        filters.tax = this.actionBar.tax; 
        this.startLoading();
        // if(filters.availability && filters.availability.length == 0){
        //   this.showProduct = false;
        // }else {
        //   this.showProduct = true;
        // }
        // Boutique listings use fetchProductsBoutique (forced price DESC, no
        // min/max price params). Keyed off `inventory` being present, the
        // agency page silently switched to it the moment a filter wrote the
        // entrepôt selection into the URL, which dropped the user's sort and
        // disabled the price filter.
        if (!this.isBoutiquePage) {
          if(!isEmpty(this.defaultShorting)){
            var shorting = this.defaultShorting.split("=");
            if(shorting[0] == 'sortByPrice'){
              this.selectedFilters.sortByPrice = shorting[1]; 
              this.selectedFilters.sortByQty = ''
            }
            if(shorting[0] == 'sortByQty'){
              this.selectedFilters.sortByQty = shorting[1]; 
              this.selectedFilters.sortByPrice = ''
            }
          }else{
            this.selectedFilters.sortByQty = '';
            this.selectedFilters.sortByPrice = '';
          }
          this.selectedFilters.page = this.currentPage;
          this.fetchProducts({ filters })
            .then(() => {
              this.stopLoading();
            })
            .catch(() => {
              this.stopLoading();
            });
        } else {
          if(!isEmpty(this.defaultShorting)){
            var shortingBout = this.defaultShorting.split("=");
            if(shortingBout[0] == 'sortByPrice'){
              this.selectedFilters.sortByPrice = shortingBout[1]; 
              this.selectedFilters.sortByQty = ''
            }
            if(shortingBout[0] == 'sortByQty'){
              this.selectedFilters.sortByQty = shortingBout[1]; 
              this.selectedFilters.sortByPrice = ''
            }
          }else{
            this.selectedFilters.sortByQty = '';
            this.selectedFilters.sortByPrice = this.$route.query.sortByPrice;
            if(this.$route.query.type != '' && this.$route.query.type != undefined){
              // this.selectedFilters.productTypes =  wrapInArray([this.$route.query.type]);
            }
          }
          this.selectedFilters.page = this.currentPage;
          // The boutique sidebar only offers Type / Prix / Disponibilité — the
          // Origine, Particularités and Entrepôts sections are hidden here. But
          // the country/region/attribute params survive in the URL when the
          // visitor arrives from the agency page, and they were still sent, so
          // the boutique came back empty ("Aucun résultats trouvés") against a
          // filter count the sidebar could neither show nor let them clear.
          // Only send what this page actually exposes.
          this.fetchProductsBoutique({
            filters: { ...filters, countries: [], regions: [], attributes: [] },
          })
            .then(() => {
              this.stopLoading();
            })
            .catch(() => {
              this.stopLoading();
            });
        }
      } else {
        this.stopLoading();
      }
      this.reRenderProductView();
    }, 500),
    updateSelectedFilters(filters) {
      // mounted() calls this with `this.selectedFilters` itself, so `filters`
      // and `this.selectedFilters` can be the same object. Read the request
      // flag before the reset below zeroes it, otherwise that self-call always
      // cancelled the pending (debounced) fetch and the list kept whatever the
      // store still held while the sidebar showed the selection as active.
      const wantsFetch = filters.req == true;

      if (filters.optionTotals) {
        this.optionTotals = filters.optionTotals;
      }

      if (filters.filterEmit == true) {
        this.currentPage = 1;
      }

      if (filters.productTypes != null) {
        this.selectedFilters.productTypes = filters.productTypes;
      }

      if (filters.availability != null) {
        this.selectedFilters.availability = filters.availability;
      }

      if (filters.attributes != null) {
        this.selectedFilters.attributes = filters.attributes;
      }

      if (filters.countries != null) {
        this.selectedFilters.countries = filters.countries;
      }

      if (filters.regions != null) {
        this.selectedFilters.regions = filters.regions;
      }

      if (filters.text != null) {
        this.selectedFilters.text = filters.text;
      }

      this.selectedFilters.req = false;
      if (wantsFetch) {
        this.startLoading();
        this.selectedFilters.req = true;
        // Sticky across the debounce window — see getProducts().
        this.pendingFetch = true;
      }
      if(filters.availabilityStatus){
        this.selectedFilters.availabilityStatus = filters.availabilityStatus;
        // this.selectedFilters.show = 'AVAILABLE_UPCOMING'
        if(filters.availabilityStatus.includes('AVAILABLE') && filters.availabilityStatus.includes('UPCOMING')){
        this.selectedFilters.show = 'AVAILABLE_UPCOMING'
        }else{
          this.selectedFilters.show = filters.availabilityStatus.toString();
        }
      }

      this.selectedFilters.minPrice = filters.minPrice;
      this.selectedFilters.maxPrice = filters.maxPrice;

      this.validateCurrentPage();

      this.selectedFilters.page = this.currentPage;
      this.selectedFilters.size = this.numberOfProductPerPage;

      this.updateFiltersCount();
      const initQuery = {
        ...this.$route.query,
        page: this.selectedFilters.page,
        size: this.selectedFilters.size,
        type: filters.productTypes,
        inventory: filters.availability,
        a: filters.attributes,
        c: filters.countries,
        r: filters.regions,
        min: filters.minPrice,
        max: filters.maxPrice,
        show: this.selectedFilters.show,
        req: filters.req ? filters.req : false
      };
      const query = {};

      forEach(initQuery, (value, key) => {
        if (value != null) {
          query[key] = value;
        }
      });
      if(query.type != null && !Array.isArray(query.type)){
        query['type'] = [query.type,''];  
      }
      if (filters.filterEmit == true) {
        this.$router
          .replace({
            query,
          })
          .catch(() => {});
      }
      this.getProducts(this.selectedFilters);
    },
    validateCurrentPage() {
      if (this.totalNumberOfPage && this.totalNumberOfPage < this.currentPage) {
        this.currentPage = this.totalNumberOfPage;
        return false;
      }

      return true;
    },
    // A section that isn't counted here also loses its "Réinitialiser" link —
    // filter-bar shows that link on `filterCount > 0` — which is how an
    // entrepôt selection became impossible to clear ("si l'entrepôt est
    // sélectionné, je peux pas la réinitialiser"). Prix and Disponibilité were
    // uncounted for the same reason. Every section the page actually shows is
    // counted now.
    //
    // Entrepôts and Disponibilité are counted only once the visitor has moved
    // them off their default (all of the market's warehouses; Disponibles + À
    // venir). Counting them raw would advertise "Filtrer (5)" on a page nobody
    // has filtered.
    isDefaultAvailabilityStatus(statuses) {
      const s = statuses || [];
      return (
        s.length === 2 &&
        s.indexOf("AVAILABLE") > -1 &&
        s.indexOf("UPCOMING") > -1
      );
    },
    narrowedCount(selected, total) {
      const chosen = selected || [];
      if (chosen.length === 0 || (total > 0 && chosen.length >= total)) {
        return 0;
      }

      return chosen.length;
    },
    narrowedAvailabilityCount(availability) {
      const selected = availability || [];
      if (selected.length === 0) {
        return 0;
      }

      const full = getDefaultAvailability(localStorage.getItem("countryCode"));
      const isWholeMarket =
        selected.length === full.length &&
        full.every((code) => selected.indexOf(code) > -1);

      return isWholeMarket ? 0 : selected.length;
    },
    updateFiltersCount() {
      const f = this.selectedFilters;

      const priceCount =
        (f.minPrice != null && f.minPrice !== "") ||
        (f.maxPrice != null && f.maxPrice !== "")
          ? 1
          : 0;
      const statusCount = this.isDefaultAvailabilityStatus(f.availabilityStatus)
        ? 0
        : (f.availabilityStatus || []).length;

      // Count only the dimensions this page actually exposes, otherwise the
      // boutique advertised "Filtrer (25)" for countries and regions its
      // sidebar hides and the visitor had no way to clear. The boutique also
      // hides Couleur and Entrepôts — there `inventory` is the store identity,
      // not a selection — so it counts Type, Prix and Disponibilité only.
      // Ticking every option is the same listing as ticking none, so a complete
      // selection is not a filter and must not be counted — otherwise
      // unticking "Tout" would slam the bar to "Filtrer (7)" and offer to reset
      // a page nobody had narrowed.
      const typeCount = this.narrowedCount(
        f.productTypes,
        this.optionTotals.productTypes
      );

      if (this.isBoutiquePage) {
        this.filterCount = typeCount + priceCount + statusCount;
        return;
      }

      this.filterCount =
        typeCount +
        this.narrowedCount(f.attributes, this.optionTotals.attributes) +
        f.countries.length +
        this.narrowedCount(f.regions, this.optionTotals.regions) +
        priceCount +
        statusCount +
        this.narrowedAvailabilityCount(f.availability);
    },
    resetSelectedFilter() {
      this.emitResetFilters();
      this.RESET_FILTERS();
    },
    emitResetFilters() {
      this.filterReset = true;

      // redirect() only rewrites the URL, and the sidebar re-seeds its trees
      // from that — but updateFiltersCount() reads `selectedFilters`, which no
      // one on this path updated. So after a reset the boxes were all back to
      // their defaults while the bar still read "Filtrer (1)" with the reset
      // link showing, and clicking it again did nothing.
      const defaultStatus = parseAvailabilityStatusQuery();
      this.selectedFilters.availabilityStatus = defaultStatus;
      this.selectedFilters.show = availabilityStatusToQuery(defaultStatus);
      this.updateFiltersCount();

      this.redirect({
        page: this.validateCurrentPage() ? this.currentPage : 1,
        size: this.numberOfProductPerPage,
        productTypes:
          this.$route.query.req && this.$route.query.type
            ? this.$route.query.type
            : [],
        // Reset Disponibilité to its default (Disponibles + À venir) like every
        // other section. This passed the CURRENT selection back, so unchecking
        // "À venir" and then hitting Réinitialiser left the page on
        // show=AVAILABLE — the one section the reset didn't reset, and clicking
        // it again changed nothing.
        availabilityStatus: parseAvailabilityStatusQuery(),
        show: availabilityStatusToQuery(parseAvailabilityStatusQuery()),
        a: [],
        c: [],
        r: [],
        minPrice: null,
        maxPrice: null,
        req: true,
      });
      // this.viewType = "tuiles";
    },
    emitToggleFilter() {
      if (this.isMobileLayout) {
        this.isMobileFilterVisible = !this.isMobileFilterVisible;
      } else {
        this.isFilterVisible = !this.isFilterVisible;
      }
    },
    handleClose() {
      this.isMobileFilterVisible = false;
    },
    initFilterReset() {
      this.filterReset = false;
    },
    clickPrevious() {
      if (this.currentPage > 1) {
        this.currentPage -= 1;
        this.selectedFilters.page = this.currentPage;
        this.selectedFilters.req = true;
        this.getProducts(this.selectedFilters);
        this.redirectAfterPageChange();
      }
    },
    clickNext() {
      if (this.currentPage < this.totalNumberOfPage) {
        this.currentPage += 1;
        this.selectedFilters.page = this.currentPage;
        this.selectedFilters.req = true;
        this.getProducts(this.selectedFilters);
        this.redirectAfterPageChange();
      }
    },
    redirectAfterPageChange() {
      this.redirect(this.selectedFilters);
    },
    redirect(filters) {
      const initQuery = {
        ...this.$route.query,
        page: filters.page,
        size: filters.size,
        type: filters.productTypes,
        // Keep the warehouse/availability (entrepôt) selection in the URL on
        // pagination, mirroring updateSelectedFilters(). Without this, changing
        // page dropped `inventory`, so the availability filter fell back to all
        // warehouses and page 2 showed every product (e.g. the SAQ filter was
        // lost when navigating past page 1).
        inventory: filters.availability,
        a: filters.attributes,
        c: filters.countries,
        r: filters.regions,
        min: filters.minPrice,
        max: filters.maxPrice,
        show: filters.show || availabilityStatusToQuery(filters.availabilityStatus),
        req: filters.req ? filters.req : false
      };
      const query = {};

      forEach(initQuery, (value, key) => {
        if (value != null) {
          query[key] = value;
        }
      });

      this.$router
        .push({
          query,
        })
        .catch(() => {});
    },
    getPDF() {
      const filters = this.selectedFilters;
      this.newWindow = window.open('', '_blank');
      if (this.newWindow) {
        this.newWindow.document.write('<html><head><title>PDF</title></head><body>');
        this.newWindow.document.write('<h4>Loading PDF...</h4>');
        this.newWindow.document.write('</body></html>');
      } else {
        console.error('Failed to open new window');
      }
      this.downloadPDF({filters}
        
      ).then((res) => {
        if (this.newWindow && res) {
          this.newWindow.location.href = res;
        }
      }).catch(() => {
        if (this.newWindow) this.newWindow.close();
      })
    },
    generatePdf() {
      this.generateReport();
    },
    generateReport() {
      this.$refs.html2Pdf.generatePdf();
    },
    hideShowpopup(desc) {
      var findATag = desc.search("</a>");
      if (findATag == -1) {
        this.hideShowPopupModel = "hide-showpopup-model";
      }
    },
    startLoading() {
      this.isLoading = true;
    },
    stopLoading() {
      this.isLoading = false;
    },
    reRenderProductView() {
      this.changeProductView = false;
      this.$nextTick(() => {
        this.changeProductView = true;
      });
    },
    shortedBy(shorting){
      this.defaultShorting = shorting;
      this.selectedFilters.page = 1;
      this.currentPage = 1;
      // if(!isEmpty(this.defaultShorting)){
        this.getProducts(this.selectedFilters);
      // }
    }
  },
};
</script>
<style scoped lang="scss">
@import "@/assets/variables.scss";

.title {
  color: $color-on-background;
}
.filter--mobile {
  height: 400px;
}
.products-subtitle {
  font-weight: $font-weight-bold !important;
}
.products-subtitle__mobile {
  line-height: 1rem;
}
.padListElement {
  padding: 1% 1% 0% 1%;
}
.el-icon-question {
  background-color: $color-primary;
  font-size: 14px;
  color: #fff;
  border-radius: 9px;
}
.el-icon-question:hover {
  cursor: pointer;
  color: $color-primary;
  background-color: #fff;
}
.no-records-found {
  height: 400px;
}
</style>
